/* TestGuard wordmark, "Test" in bluish-purple, "Guard" in gold. */
export function TGWordmark({ className = "" }) {
  return (
    <span className={className} data-testid="tg-wordmark">
      <span style={{ color: "#7C6FF5" }}>Test</span>
      <span style={{ color: "#E3B23C" }}>Guard</span>
    </span>
  );
}
